export class PersonalFilter {
    public id: string;
    public customUserFilters: Array<CustomFilter>;
}

export class CustomFilter{
    public customTag: string;
    public filters: Category;
}

export class Category{
    public extension:Array<string>;
    public restriction:Array<string>;
    public tag:Array<string>;
    public sortKey: number;
    public BusinessCategory: string;
}